import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-dialog-leave',
  templateUrl: './dialog-leave.component.html',
  styleUrls: ['./dialog-leave.component.scss']
})
export class DialogLeaveComponent {
  constructor(
    public dialogRef: MatDialogRef<DialogLeaveComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  onNoClick(): void {
    this.dialogRef.close();
  }
}
